import produce from "immer";
import { COMMIT_SELECTIONS } from "state/selections/actionTypes";
import {
  RECEIVE_ATTRIBUTE_DATA,
  RECEIVE_ATTRIBUTE_VALUES,
  RECEIVE_ENTITY_ATTRIBUTES,
  REQUEST_ATTRIBUTE_DATA,
  REQUEST_ATTRIBUTE_VALUES,
  REQUEST_ENTITY_ATTRIBUTES,
  SET_DEFINITION,
  SET_DEFINITIONS,
} from "./actions";
import SelectionState from "state/selections/SelectionState";
import AttributeDefinition from "./AttributeDefinition";
import {
  removeDefinitionFromState,
  setDefinitionToState,
} from "state/grid/utils";
import { DELETE_COLUMN } from "state/grid/actions";

const defaultState = {
  definitions: {
    [SelectionState.UNCOMMITTED]: [AttributeDefinition.getDefault()],
    [SelectionState.COMMITTED]: [],
  },
  fetchingAttributeData: false,
  attributeData: null,
  fetchingAttributeValues: false,
  attributeValues: [],
  fetchingEntityAttributes: false,
  entityAttributes: [],
};

const reducer = produce((state = defaultState, action) => {
  switch (action.type) {
    case SET_DEFINITION: {
      return setDefinitionToState(state, action.idx, action.definition);
    }
    case DELETE_COLUMN: {
      return removeDefinitionFromState(state, action.payload);
    }
    case SET_DEFINITIONS: {
      state.definitions[SelectionState.UNCOMMITTED] = action.definitions;
      break;
    }
    case COMMIT_SELECTIONS: {
      state.attributeData = defaultState.attributeData;
      state.definitions[SelectionState.COMMITTED] =
        state.definitions[SelectionState.UNCOMMITTED];
      break;
    }

    case REQUEST_ATTRIBUTE_DATA: {
      state.fetchingAttributeData = true;
      state.attributeData = defaultState.attributeData;
      break;
    }

    case RECEIVE_ATTRIBUTE_DATA: {
      state.fetchingAttributeData = false;
      state.attributeData = action.data;
      break;
    }

    case REQUEST_ATTRIBUTE_VALUES: {
      state.fetchingAttributeValues = true;
      state.attributeValues = defaultState.attributeValues;
      break;
    }
    case RECEIVE_ATTRIBUTE_VALUES: {
      state.fetchingAttributeValues = false;
      state.attributeValues = action.data;
      break;
    }

    case REQUEST_ENTITY_ATTRIBUTES: {
      state.fetchingEntityAttributes = true;
      state.entityAttributes = defaultState.entityAttributes;
      break;
    }
    case RECEIVE_ENTITY_ATTRIBUTES: {
      state.fetchingEntityAttributes = false;
      state.entityAttributes = action.data;
      break;
    }
    default:
      return state;
  }
});

export default reducer;
